export const APPLICATION_BOOTSTRAPPED = 'APPLICATION_BOOTSTRAPPED';

export const applicationBootstrapped = () => ({
  type: APPLICATION_BOOTSTRAPPED
});
